import Box from '@mui/material/Box'
import styled from '@emotion/styled'

const CursorBox = styled(Box)`
  cursor: pointer;
`

export default CursorBox
